import {getDateDDMMYYUtc} from "./timestampService";

export function getHistoryByDaySum(history) {
    const locHistory = history.sort(sortHistory);
    let convertingHistory = [];

    locHistory.forEach((item, index) => {
        const nexDay = locHistory[index + 1]
        if(nexDay &&  !compareDate(nexDay.CreatedDate, item.CreatedDate)) {
            convertingHistory.push({
                CreatedDate : item.CreatedDate,
                Stake: item.Stake,
                Win: item.Win,
                Prediction: item.Prediction,
                startDay: true
            })
        } else {
            convertingHistory.push({
                CreatedDate : item.CreatedDate,
                Stake: item.Stake,
                Win: item.Win,
                Prediction: item.Prediction,
            })
        }


    })

    return convertingHistory
}

export function sortHistory(a,b) {
    return new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime()
}


export function compareDate(dateA, dateB) {
    return getDateDDMMYYUtc(dateA) === getDateDDMMYYUtc(dateB)
}
